import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoopOutlinedIcon from "@mui/icons-material/LoopOutlined";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import ThumbDownAltOutlinedIcon from "@mui/icons-material/ThumbDownAltOutlined";
import { Routepath } from "../../../routing/routpath";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  Tab,
  Tabs,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import { groupLookup } from "../../../utils/helpers";
import {
  getCandidateById,
  submitNotification,
  PostComment,
} from "../../../services/apiRequests";
import useAuth from "../../../hooks/useAuth";
import {
  dashboard_api,
  renderCandidateStatus,
} from "../../../constance/DashboardJson";
import { useSelector } from "react-redux";
import { map, isEmpty, find } from "lodash";
import dayjs from "dayjs";
import useLoader from "../../../Loader/useLoader";
import { Box, Button, Grid, Typography, Icon } from "@mui/material";
import { MarkUpTable } from "../../../CommonContainer/MarkUpTable";
import { B2BIMariginLimits } from "../../../CommonContainer/B2BIMariginLimits";
import { PayBenefits } from "../../../CommonContainer/PayBenefits";
import { useScreenId } from "../../../hooks/useScreenId";
import CircleIcon from "@mui/icons-material/Circle";
import toast from "react-hot-toast";
import AreYouSureModel from "../../../CommonContainer/AreYouSureModel";
import SucessModel from "../../../CommonContainer/SucessModel";
import { Controller, useForm } from "react-hook-form";
import usflag from "../../../assets/Images/us.png";
import CANADAflag from "../../../assets/Images/canada.png";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import { makeStyles } from "@mui/styles";
import { styled } from "@mui/material/styles";
import Field from "../../../components/Field";
import CoTextField from "../../../components/CoTextField";
import CoDatePicker from "../../../components/CoDatePicker";
import CoDropdown from "../../../components/CoDropdown/CoDropdown";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const SquareRadio = styled(Radio)(({ theme }) => ({
  "& .MuiSvgIcon-root": {
    borderRadius: "0%",
    width: "20px",
    marginLeft: "3px",
    height: "20px",
  },
  "&.Mui-checked .MuiSvgIcon-root": {
    borderRadius: "0%",
    width: "20px",
    height: "20px",
  },
}));

const useStyles = makeStyles((theme) => ({
  usFlag: {
    width: "40px",
    height: "24px",
    background: `url(${usflag})`,
    backgroundColor: "lightgray",
    backgroundPosition: "-2.977px -4.849px",
    backgroundSize: "112.59% 140.42%",
    backgroundRepeat: "no-repeat",
  },
  CANADAflag: {
    width: "40px",
    height: "24px",
    background: `url(${CANADAflag})`,
    backgroundColor: "lightgray",
    backgroundPosition: "-2.977px -4.849px",
    backgroundSize: "112.59% 140.42%",
    backgroundRepeat: "no-repeat",
  },
}));

const AccountExeContent = () => {
  const navigate = useNavigate();
  const [candidateDetails, setCandidateDetails] = useState({});
  const candidateList = useSelector((state) => state.dropedField);
  const employIntegration = useSelector((state) => {
    return state.dropedField;
  });
  const { getAccess } = useAuth();
  const { noAccess: totalComoer24 } = getAccess("10");
  const { noAccess: reMntlyCmsPH } = getAccess("11");
  const { noAccess: tcmnsPH } = getAccess("12");
  const { noAccess: hrlyRate } = getAccess("13");
  const { noAccess: Boarding } = getAccess("15");
  const { noAccess: termination } = getAccess("16");
  const { noAccess: calcCountry } = getAccess("17");
  const [vmsForBu, setvmsForBu] = useState();
  const [lookupGroup, setLookupGroup] = useState({});
  const [VMSFee, setVmsFee] = useState([]);
  const [apiIntegrated, setApiIntegrated] = useState(false);
  const [showLoader, hideLoader] = useLoader();
  const [approved, setApproved] = useState(false);
  const [alignment, setAlignment] = useState("USA");
  const [tabIndex, setTabIndex] = useState(0);
  const [openMarkup, setOpenMarkup] = useState(false);
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  const visibleAccess = {
    recuiterMonthlyCommissionPerHour: totalComoer24,
    totalCommissionForMonthPro: reMntlyCmsPH,
    recruiterMonthlyCommissionPro: tcmnsPH,
    hourlyRate: hrlyRate,
    onboardingDt: Boarding,
    terminationDt: termination,
    calculationCountry: calcCountry,
  };

  const userSchema = yup.object({
    candidateName: yup.string().required("Enter Candidate Name"),
    candidateJobTitle: yup.string().required("Enter Candidate Job Title"),
    candidateStartDt: yup.string().required("Please Select the date"),
    candidateBillRate: yup.string().required("Enter Bill Rate"),
    payRate: yup.string().required("Enter Pay Rate"),
    candidateCountry: yup.string().required("Select Working Location"),
    candidateBusinessUnit: yup.string().required("Select Business Unit"),
    candidateTypeOfResource: yup.string().required("Select Resource Type"),
    vmsFee: yup.string().required("Select VMS Fee"),
    vacationNoOfDays: yup
      .string()
      .when(["candidateCountry", "candidateTypeOfResource"], {
        is: (country, type) => country === "CAD" || type !== "C2C",
        then: (schema) => schema.required("Enter Vacation Days"),
      }),

    sickLeaveNoOfDays: yup.string().when("candidateTypeOfResource", {
      is: (type) => type !== "C2C",
      then: (schema) => schema.required("Enter Sick Leave Days"),
    }),
    provinceState: yup.string().when("candidateCountry", {
      is: (type) => type === "CAD",
      then: (schema) => schema.required("Select Provience State"),
    }),
    refferalAmount: yup.string().when("candidateTypeOfResource", {
      is: (type) => type !== "C2C",
      then: (schema) => schema.required("Enter Referral Amount"),
    }),
    immgirationType: yup
      .string()
      .when(["candidateCountry", "candidateTypeOfResource"], {
        is: (country, type) => country === "CAD" || type !== "C2C",
        then: (schema) => schema.required("Enter Immigration Type"),
      }),

    otherExpenses: yup.string().when("candidateTypeOfResource", {
      is: (type) => type !== "C2C",
      then: (schema) => schema.required("Enter Other Expenses"),
    }),
    candidateInsurenceType: yup
      .string()
      .when(["candidateTypeOfResource", "candidateCountry"], {
        is: (type, country) => type !== "C2C" || country === "CAD",
        then: (schema) => schema.required("Select Insurance Type"),
      }),
    holidays: yup
      .string()
      .when(["candidateCountry", "candidateTypeOfResource"], {
        is: (country, type) => country === "CAD" || type !== "C2C",
        then: (schema) => schema.required("Select Holidays"),
      }),
    otherExpensesHourly: yup
      .string()
      .when(["candidateTypeOfResource", "candidateCountry"], {
        is: (type, country) => type !== "C2C" || country === "CAD",
        then: (schema) => schema.required("Enter Other Expenses Hourly"),
      }),
    leaveStateCd: yup.string().when("candidateCountry", {
      is: "USA",
      then: (schema) => schema.required("Select State"),
      otherwise: (schema) => schema.notRequired(), // Ensure fallback behavior
    }),
    comment: yup.string().required("Enter Comment"),
  });

  const {
    control,
    watch,
    setValue,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(userSchema),
    defaultValues: {
      ...candidateDetails,
      candidateStartDt: candidateDetails?.candidateStartDt
        ? dayjs(candidateDetails?.candidateStartDt, "YYYY-MM-DD")
        : null,
      onboardingDt: candidateDetails?.onboardingDt
        ? dayjs(candidateDetails?.onboardingDt, "YYYY-MM-DD")
        : null,
      terminationDt: candidateDetails?.terminationDt
        ? dayjs(candidateDetails?.terminationDt, "YYYY-MM-DD")
        : null,
      candidateDetailId: candidateDetails?.candidateDetailId ?? null,
      comment: "",
    },
  });

  useEffect(() => {
    if (candidateDetails) {
      reset({
        ...candidateDetails,
        candidateStartDt: candidateDetails?.candidateStartDt
          ? dayjs(candidateDetails?.candidateStartDt, "YYYY-MM-DD")
          : null,
        onboardingDt: candidateDetails?.onboardingDt
          ? dayjs(candidateDetails?.onboardingDt, "YYYY-MM-DD")
          : null,
        terminationDt: candidateDetails?.terminationDt
          ? dayjs(candidateDetails?.terminationDt, "YYYY-MM-DD")
          : null,
        candidateDetailId: candidateDetails?.candidateDetailId ?? null,
      });
    }
  }, [candidateDetails, reset]);

  const immigration = watch("immgirationType");
  const tnVisaCountry = watch("tnVisaCountry");
  const businessUnit = watch("candidateBusinessUnit");
  const workingLocation = watch("candidateCountry");
  const calCountry = watch("calculationCountry");
  const vmsFee = watch("vmsFee");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setApproved(false);
  };

  const findFullform = (shortHand) => {
    const status = lookupGroup["CANDIDATE_STATUS"];
    const longHand = find(status, (key) => key.value === shortHand);
    return longHand?.label;
  };

  useScreenId(
    6,
    () => {
      getNotificationTables();
    },
    [],
    [apiIntegrated]
  );

  const getNotificationTables = async () => {
    try {
      showLoader();
      if (
        employIntegration.Notification.Event === "View" ||
        employIntegration.Notification.Event === "Edit"
      ) {
        let response = await getCandidateById(
          "getbycandidateid",
          employIntegration.Notification.id
        );
        const extractedData = map(
          candidateList.vmsFee,
          ({ customerNameWithFee, vmsId }) => ({
            label: customerNameWithFee,
            value: vmsId,
          })
        );
        const BuforVms = candidateList.vmsFee.reduce((acc, current) => {
          if (acc[current.bussinessUnit]) {
            acc[current.bussinessUnit].push({
              label: current.customerNameWithFee,
              value: current.vmsId,
              markup: current.allowedMarkupPct,
            });
          } else {
            acc[current.bussinessUnit] = [
              {
                label: current.customerNameWithFee,
                value: current.vmsId,
                markup: current.allowedMarkupPct,
              },
            ];
          }
          return acc;
        }, {});

        setvmsForBu(BuforVms);
        if (
          candidateList?.lookup &&
          Object.keys(candidateList?.lookup).length > 0
        ) {
          const groupedLookup = groupLookup(candidateList?.lookup);
          setLookupGroup(groupedLookup);
          const vmsFor = response.hasOwnProperty("candidateDetailId")
            ? BuforVms[response.candidateBusinessUnit]
              ? BuforVms[response.candidateBusinessUnit]
              : []
            : extractedData;
          setVmsFee({ VMS: vmsFor });

          let tempData = { ...response.data };
          tempData["country"] = employIntegration.loginData.country;
          tempData["recuriterId"] = employIntegration.loginData.id;
          setCandidateDetails({ ...tempData, comments: "" });
        }
      }
    } catch (error) {
      toast.error("Server Error");
    } finally {
      hideLoader();
    }
  };

  const saveComment = async (data) => {
    try {
      showLoader();
      const payload = {
        commentDesc: data.comment,
        applicationId: data.applicationId,
      };
      await PostComment(payload);
    } catch (error) {
    } finally {
      hideLoader();
    }
  };

  const saveAndPost = async (userActions, data) => {
    try {
      showLoader();
      let payload = {
        ...data,
        candidateStartDt: data?.candidateStartDt
          ? dayjs(data?.candidateStartDt).format("YYYY-MM-DD")
          : null,
        terminationDt: data?.terminationDt
          ? dayjs(data?.terminationDt).format("YYYY-MM-DD")
          : null,
        country: employIntegration.loginData.country,
        loginUserId: employIntegration.loginData.id,
        candidateStatus: userActions,
      };
      if (userActions === "Approved") {
        payload = {
          ...payload,
          onboardingDt: data?.candidateStartDt
            ? dayjs(data.candidateStartDt).isValid()
              ? dayjs(data.candidateStartDt).format("YYYY-MM-DD")
              : null
            : null,
        };
      }
      const res = await submitNotification(
        candidateDetails.applicationId,
        payload
      );
      if (res.status === 200) {
        setOpen(false);
        setApproved(false);
        saveComment(data);
        setApiIntegrated(!apiIntegrated); //settttt notification,check changes
        navigate(Routepath.DashboardTabsAll);
      }
      setCandidateDetails({ ...dashboard_api });
    } catch (error) {
      console.error("Error saving comment:", error);

      if (error?.response) {
        toast.error(
          error?.response?.data?.message ||
            "Something went wrong. Please try again."
        );
      } else if (error?.request) {
        toast.error("Network error. Please check your internet connection.");
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    } finally {
      hideLoader();
    }
  };

  const displayRules = (name) => {
    let BooleanResult = true;

    if (["Allowance"].includes(name)) {
      candidateDetails.candidateCountry === "CAD"
        ? (BooleanResult = false)
        : (BooleanResult = true);
    }
    if (["Total Commission for # months"].includes(name)) {
      candidateList.loginData.country === "India"
        ? (BooleanResult = false)
        : (BooleanResult = true);
    }
    if (name === "leaveStateCd") {
      candidateList.candidateCountry === "USA"
        ? (BooleanResult = false)
        : (BooleanResult = true);
    }
    if (["calculationCountry"].includes(name)) {
      candidateList.loginData.country === "India"
        ? (BooleanResult = false)
        : (BooleanResult = true);
    }
    if (["recMnthlyCommissionBonus"].includes(name)) {
      candidateList.loginData.country === "India"
        ? (BooleanResult = true)
        : (BooleanResult = false);
    }
    if (
      [
        "provinceState",
        "statutoryHolidays",
        "vacationPayHourly",
        "vacationPayAnnual",
        "optionalHolidays",
        "ttlMonthlyCommissionUSDVal",
        "recruiterMonthlyCommissionUSDVal",
      ].includes(name)
    ) {
      candidateDetails.candidateCountry === "CAD"
        ? (BooleanResult = true)
        : (BooleanResult = false);
    }
    if (
      ["totalCommissionForMonthPro", "recruiterMonthlyCommissionPro"].includes(
        name
      )
    ) {
      candidateList.loginData.country === "India"
        ? (BooleanResult = false)
        : (BooleanResult = true);
    }
    if (
      [
        "ttlMonthlyCommissionUSDVal",
        "recruiterMonthlyCommissionUSDVal",
      ].includes(name)
    ) {
      if (
        candidateDetails.candidateCountry === "CAD" &&
        candidateList.loginData.country === "USA"
      ) {
        BooleanResult = true;
      } else BooleanResult = false;
    }
    if (
      [
        "ttlMonthlyCommissionUSDVal",
        "recruiterMonthlyCommissionUSDVal",
      ].includes(name)
    ) {
      if (
        candidateDetails.candidateCountry === "CAD" &&
        candidateList.loginData.country === "India"
      ) {
        BooleanResult = false;
      }
    }
    if (
      [
        "vacationNoOfDays",
        "candidateInsurenceType",
        "holidays",
        "immgirationType",
        "otherExpensesHourly",
        "totalCommissionForMonthPro",
        "recruiterMonthlyCommissionPro",
        "hourlyRate",
        "perDiemCount",
        "perDiem",
        "payRatePerDiem",
        "recruiterMonthlyCommission",
        "recuiterMonthlyCommissionPerHour",
      ].includes(name)
    ) {
      candidateDetails.candidateCountry === "CAD"
        ? (BooleanResult = false)
        : (BooleanResult = true);
    }
    return BooleanResult;
  };

  const setMydivName = (name, divName) => {
    let myDivName = "";
    if (calCountry === "CAD" || candidateList.loginData.country === "Canada") {
      switch (name) {
        case "recuiterMonthlyCommission": {
          myDivName = "Recruiter Monthly Commission(CAD)";
          break;
        }
        case "totalCommissionFor24Months": {
          myDivName = "Total Commission for # months (CAD)";
          break;
        }
        default:
          myDivName = divName;
      }
    } else myDivName = divName;
    return myDivName;
  };

  const chooseDropdoenOptions = (type) => {
    let filteredOption = lookupGroup[type];
    if (type === "RESOURCETYPE") {
      if (candidateDetails.candidateCountry === "CAD") {
        const filteredOptions = lookupGroup["RESOURCETYPE"].filter(
          (key) => key.label === "T4"
        );

        filteredOption = filteredOptions;
      } else {
        const filteredOptions = lookupGroup["RESOURCETYPE"].filter(
          (key) => key.label !== "T4"
        );

        filteredOption = filteredOptions;
      }
    }
    return filteredOption;
  };

  const currencySymbol = () => {
    const commissionCurrency =
      candidateList.loginData.roleCd !== "RCTR" &&
      candidateList.loginData.roleCd !== "ACCMNGR"
        ? watch("calculationCountry") === "India"
          ? "IND"
          : watch("calculationCountry") === "USA"
          ? "USA"
          : candidateList.loginData.country === "India"
          ? "IND"
          : candidateList.loginData.country === "USA"
          ? "USA"
          : "CAD"
        : "";

    return commissionCurrency === "IND" ? "₹" : "$";
  };

  useEffect(() => {
    if (!businessUnit || !vmsForBu) return; // Ensure vmsForBu is defined
    const vmsFor = vmsForBu[businessUnit] ?? []; // Use optional chaining or fallback
    if (vmsFor.length > 0) {
      setValue("vmsFee", vmsFee || ""); // Set first option as default
    } else {
      setValue("vmsFee", ""); // Clear selection if no options
    }
    setVmsFee({ VMS: vmsFor });
  }, [businessUnit, vmsForBu, setValue]); // Add dependency on vmsForBu

  useEffect(() => {
    if (immigration !== 4000) {
      setValue("tnVisaCountry", ""); // Reset country field
      setValue("tnVisaPremiumYN", ""); // Reset premium field
    }
  }, [immigration, setValue]); // Runs when immigration changes

  useEffect(() => {
    if (!businessUnit || !vmsForBu || !vmsForBu.hasOwnProperty(businessUnit))
      return;

    const getMarkup = vmsForBu[businessUnit]?.find(
      (obj) => obj.value === watch("vmsFee")
    );

    setValue(
      "allowedMarkupPct",
      getMarkup?.markup
        ? getMarkup?.markup === "NA"
          ? "No Markup"
          : getMarkup?.markup
        : "--"
    );
  }, [watch("vmsFee"), businessUnit, vmsForBu]); // Added vmsForBu as a dependency

  useEffect(() => {
    if (workingLocation) {
      setAlignment(workingLocation);
    }
  }, [workingLocation]);

  const tabs = [
    candidateDetails?.rtMarkUpModel && { label: "Mark Up List", key: "markUp" },
    candidateDetails?.prFinalRateModel && {
      label: "Pay Benefits",
      key: "payBenefits",
    },
    candidateDetails?.rtMarkUpModel && {
      label: "B2BI Margin Limit",
      key: "b2bi",
    },
  ].filter(Boolean);

  useEffect(() => {
    if (!watch("tnVisaCountry")) {
      setValue("tnVisaCountry", candidateDetails.tnVisaCountry ?? ""); // Set default value if it's empty
      setValue("tnVisaPremiumYN", candidateDetails.tnVisaPremiumYN ?? ""); // Set default value if it's empty
    }
  }, [watch("tnVisaCountry"), setValue, candidateDetails]);

  const returnDialogue = () => {
    toast.custom((t) => (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          padding: "16px",
          position: "absolute",
          top: "50%",
          borderRadius: "8px",
          background: "#fff",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <div style={{ marginBottom: "8px" }}>
          <strong>Do You want to Return this Application?</strong>
        </div>
        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <button
            style={{
              background: "#4CAF50",
              color: "white",
              padding: "8px 12px",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => {
              toast.dismiss(t.id);
              handleSubmit(
                (data) => {
                  saveAndPost("Returned", data);
                },
                (errors) => {
                  console.log("Validation Errors:", errors); // Log errors if validation fails
                }
              )();
            }}
          >
            Yes
          </button>
          <button
            style={{
              background: "#f44336",
              color: "white",
              padding: "8px 12px",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
            onClick={() => {
              toast.dismiss(t.id); // Close toast
            }}
          >
            No
          </button>
        </div>
      </div>
    ));
  };

  return (
    <>
      <Grid
        container
        sx={{
          background: "#44A0E3",
          p: 1,
          justifyContent: "flex-start",
          alignItems: "flex-start",
          position: "sticky",
          overflow: "auto",
          right: "10px",
          top: "55px",
          zIndex: 1,
        }}
      >
        <Grid item sx={{ display: "flex" }} xs={3}>
          <Typography variant="h7" sx={{ color: "#FFF" }}>
            Application Id:
          </Typography>
          <Typography variant="h7" sx={{ color: "#FFF" }}>
            {candidateDetails.applicationId}
          </Typography>
        </Grid>
        <Grid item sx={{ display: "flex" }} xs={3}>
          <Typography variant="h7" sx={{ color: "#FFF" }}>
            Candidate Name:
          </Typography>
          <Typography variant="h7" sx={{ color: "#FFF" }}>
            {candidateDetails.candidateName}
          </Typography>
        </Grid>
        <Grid item sx={{ display: "flex" }} xs={3}>
          <Typography variant="h7" sx={{ color: "#FFF" }}>
            Recruiter Name:
          </Typography>
          <Typography variant="h7" sx={{ color: "#FFF" }}>
            {candidateDetails.recuiterFirstName}{" "}
            {candidateDetails.recuiterLastName}
          </Typography>
        </Grid>
        <Grid item sx={{ display: "flex", gap: "2px" }} xs={3}>
          <Typography variant="h7" sx={{ color: "#FFF" }}>
            Candidate Status:
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <CircleIcon
              sx={{
                color:
                  renderCandidateStatus?.[
                    findFullform(candidateDetails?.candidateStatus)
                  ] ?? "white",
                width: "15px",
              }}
            />
            <Typography variant="h7" sx={{ color: "#FFF" }}>
              {findFullform(candidateDetails?.candidateStatus)}
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Grid container>
        {candidateDetails?.rtMarkUpModel && (
          <IconButton
            sx={{
              position: "fixed",
              top: 130,
              right: 20,
              background: "#616161",
              boxShadow: 2,
              color: "white",
              zIndex: 9999,
              "&:hover": {
                background: "#424242",
                color: "#f5f5f5",
                transform: "scale(1.1)",
                transition: "all 0.3s ease",
              },
            }}
            onClick={() => setOpenMarkup(true)}
          >
            <MonetizationOnOutlinedIcon />
          </IconButton>
        )}

        <Dialog
          open={openMarkup}
          onClose={() => setOpenMarkup(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            <Typography variant="h6">Candidate Details</Typography>
          </DialogTitle>
          <DialogContent sx={{ height: "25rem" }}>
            {tabs.length > 0 ? (
              <>
                <Tabs
                  value={tabIndex}
                  onChange={(e, newIndex) => setTabIndex(newIndex)}
                >
                  {tabs.map((tab, index) => (
                    <Tab key={index} label={tab.label} />
                  ))}
                </Tabs>
                {tabs[tabIndex]?.key === "markUp" && (
                  <Box p={2}>
                    <MarkUpTable value={candidateDetails?.rtMarkUpModel} />
                  </Box>
                )}

                {tabs[tabIndex]?.key === "payBenefits" && (
                  <Box p={2}>
                    <PayBenefits value={candidateDetails?.prFinalRateModel} />
                  </Box>
                )}

                {tabs[tabIndex]?.key === "b2bi" && (
                  <Box p={2}>
                    {!isEmpty(lookupGroup) && (
                      <B2BIMariginLimits value={lookupGroup} />
                    )}
                  </Box>
                )}
              </>
            ) : (
              <Typography>No Data Available</Typography>
            )}
          </DialogContent>
        </Dialog>
        <Grid item xs={12} sx={{ padding: "0px 16px 16px 16px" }}>
          {!isEmpty(lookupGroup) ? (
            <>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "center",
                  padding: "20px",
                }}
              >
                <ToggleButtonGroup
                  sx={{
                    backgroundColor: "#EEEEEE",
                    borderRadius: "15px ",
                    border: "solid 0.5px #616161",
                  }}
                  value={alignment}
                  exclusive
                  aria-label="Platform"
                >
                  <ToggleButton
                    value="USA"
                    sx={{
                      display: "flex",
                      gap: "10px",
                      textTransform: "capitalize",
                      "&.Mui-selected, &.Mui-selected:hover": {
                        backgroundColor: "#616161",
                      },
                      borderRadius: "14px",
                      backgroundColor: "white",
                    }}
                  >
                    <div className={classes.usFlag}></div>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontSize: 15,
                        fontWeight: alignment === "USA" ? "bold" : 500,
                        color: alignment === "USA" ? "#FFFF" : "#6c6c6c",
                      }}
                    >
                      United State
                    </Typography>
                  </ToggleButton>
                  <ToggleButton
                    value="CAD"
                    sx={{
                      display: "flex",
                      gap: "10px",
                      textTransform: "capitalize",
                      "&.Mui-selected, &.Mui-selected:hover": {
                        color: "#FFFF",
                        backgroundColor: "#616161",
                      },
                      borderRadius: "14px",
                      outline: alignment === "CAD" ? "solid 1px gray" : "none",
                      backgroundColor: "white",
                    }}
                  >
                    <div className={classes.CANADAflag}></div>
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontWeight: alignment === "CAD" ? "bold" : 500,
                        color: alignment === "CAD" ? "#FFFF" : "#6c6c6c",
                      }}
                    >
                      Canada
                    </Typography>
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>

              <Grid container gap={2}>
                <Grid item xs={12}>
                  <Accordion defaultExpanded>
                    <AccordionSummary
                      sx={{
                        border: "#D9D9D9 solid 1px",
                        boxShadow: "2px 2px 4px 0px rgba(1, 1, 22, 0.16)",
                      }}
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <Typography sx={{ fontWeight: 700 }}>
                        Employee Information
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={4}>
                          <Field
                            label="Candidate Name"
                            required
                            error={errors?.candidateName?.message}
                            showError={errors?.candidateName?.message}
                          >
                            <CoTextField
                              name="candidateName"
                              control={control}
                              disabled={true}
                            />
                          </Field>
                        </Grid>
                        <Grid item xs={4}>
                          <Field
                            label="Job Title"
                            required
                            error={errors?.candidateJobTitle?.message}
                            showError={errors?.candidateJobTitle?.message}
                          >
                            <CoTextField
                              name="candidateJobTitle"
                              control={control}
                              disabled={true}
                            />
                          </Field>
                        </Grid>
                        <Grid item xs={4}>
                          <Field label="Job ID">
                            <CoTextField
                              name="jobId"
                              control={control}
                              disabled={true}
                            />
                          </Field>
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid item xs={4}>
                          <Field
                            label="Start Date"
                            isDate
                            required
                            error={errors?.candidateStartDt?.message}
                            showError={errors?.candidateStartDt?.message}
                          >
                            <CoDatePicker
                              name="candidateStartDt"
                              control={control}
                            />
                          </Field>
                        </Grid>
                        {displayRules("onboardingDt") && (
                          <Grid item xs={4}>
                            <Field label="On Bording Date" isDate>
                              <CoDatePicker
                                name="onboardingDt"
                                control={control}
                              />
                            </Field>
                          </Grid>
                        )}
                        <Grid item xs={4}>
                          <Field label="Termination Date" isDate>
                            <CoDatePicker
                              name="terminationDt"
                              control={control}
                            />
                          </Field>
                        </Grid>
                      </Grid>
                      <Grid item xs={4}></Grid>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
                <Grid item xs={12}>
                  <Accordion defaultExpanded>
                    <AccordionSummary
                      sx={{
                        border: "#D9D9D9 solid 1px",
                        boxShadow: "2px 2px 4px 0px rgba(1, 1, 22, 0.16)",
                      }}
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <Typography sx={{ fontWeight: 700 }}>
                        Billing & Staffing Information
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={4}>
                          <Field
                            label="Bill Rate"
                            required
                            error={errors?.candidateBillRate?.message}
                            showError={errors?.candidateBillRate?.message}
                          >
                            <CoTextField
                              name="candidateBillRate"
                              control={control}
                              disabled={true}
                              startAdornment={
                                <InputAdornment position="start">
                                  $
                                </InputAdornment>
                              }
                            />
                          </Field>
                        </Grid>
                        <Grid item xs={4}>
                          <Field
                            label="Pay Rate"
                            required
                            error={errors?.payRate?.message}
                            showError={errors?.payRate?.message}
                          >
                            <CoTextField
                              name="payRate"
                              control={control}
                              disabled={true}
                              startAdornment={
                                <InputAdornment position="start">
                                  $
                                </InputAdornment>
                              }
                            />
                          </Field>
                        </Grid>
                        <Grid item xs={4}>
                          <Field
                            label="Working Location"
                            required
                            error={errors?.candidateCountry?.message}
                            showError={errors?.candidateCountry?.message}
                          >
                            <CoDropdown
                              name="candidateCountry"
                              control={control}
                              disabled={true}
                              options={chooseDropdoenOptions("COUNTRY")}
                            />
                          </Field>
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        {displayRules("calculationCountry") &&
                          !visibleAccess["calculationCountry"] && (
                            <Grid item xs={4}>
                              <Field
                                label="Calculation Location"
                                required
                                error={errors?.candidateCountry?.message}
                                showError={errors?.candidateCountry?.message}
                              >
                                <CoDropdown
                                  name="calculationCountry"
                                  control={control}
                                  disabled={true}
                                  options={chooseDropdoenOptions("CALCOUNTRY")}
                                />
                              </Field>
                            </Grid>
                          )}
                        {displayRules("leaveStateCd") && (
                          <Grid item xs={4}>
                            <Field
                              label="State"
                              required
                              error={errors?.leaveStateCd?.message}
                              showError={errors?.leaveStateCd?.message}
                            >
                              <CoDropdown
                                name="leaveStateCd"
                                control={control}
                                disabled={true}
                                options={chooseDropdoenOptions("STATE")}
                              />
                            </Field>
                          </Grid>
                        )}
                        <Grid item xs={4}>
                          <Field
                            label="Business Unit"
                            required
                            error={errors?.candidateBusinessUnit?.message}
                            showError={errors?.candidateBusinessUnit?.message}
                          >
                            <CoDropdown
                              name="candidateBusinessUnit"
                              control={control}
                              disabled={true}
                              options={chooseDropdoenOptions("BUSINESSUNIT")}
                            />
                          </Field>
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid item xs={4}>
                          <Field label="Recruiter Name">
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "14px",
                              }}
                            >
                              <CoTextField
                                name="recuiterFirstName"
                                control={control}
                                sx={{ width: "100%" }}
                                disabled={true}
                              />
                              <CoTextField
                                name="recuiterLastName"
                                control={control}
                                sx={{ width: "100%" }}
                                disabled={true}
                              />
                            </Box>
                          </Field>
                        </Grid>
                        <Grid item xs={4}>
                          <Field label="Pre-ID">
                            <CoDropdown
                              name="preId"
                              disabled={true}
                              control={control}
                              options={chooseDropdoenOptions("YESNO")}
                            />
                          </Field>
                        </Grid>
                        <Grid item xs={4}>
                          <Field
                            label="Type of Resource"
                            required
                            error={errors?.candidateTypeOfResource?.message}
                            showError={errors?.candidateTypeOfResource?.message}
                          >
                            <CoDropdown
                              name="candidateTypeOfResource"
                              control={control}
                              disabled={true}
                              options={chooseDropdoenOptions("RESOURCETYPE")}
                            />
                          </Field>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
                <Grid item xs={12}>
                  <Accordion defaultExpanded>
                    <AccordionSummary
                      sx={{
                        border: "#D9D9D9 solid 1px",
                        boxShadow: "2px 2px 4px 0px rgba(1, 1, 22, 0.16)",
                      }}
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <Typography sx={{ fontWeight: 700 }}>
                        Compensation & Benefits Information
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={4}>
                          <Field
                            label="VMS Fee"
                            required
                            error={errors?.vmsFee?.message}
                            showError={errors?.vmsFee?.message}
                          >
                            <CoDropdown
                              name="vmsFee"
                              control={control}
                              disabled={true}
                              options={VMSFee.VMS}
                            />
                          </Field>
                        </Grid>
                        <Grid item xs={4}>
                          <Field label="Allowed Markup">
                            <CoTextField
                              name="allowedMarkupPct"
                              control={control}
                              disabled={true}
                              isPercentage={true}
                            />
                          </Field>
                        </Grid>
                        {displayRules("holidays") && (
                          <Grid item xs={4}>
                            <Field label="Holidays (6 Days)">
                              <CoDropdown
                                name="holidays"
                                control={control}
                                disabled={true}
                                options={chooseDropdoenOptions("YESNO")}
                              />
                            </Field>
                          </Grid>
                        )}
                      </Grid>
                      {(displayRules("provinceState") ||
                        displayRules("vacationPayHourly") ||
                        displayRules("vacationPayAnnual")) && (
                        <Grid container spacing={2}>
                          {displayRules("provinceState") && (
                            <Grid item xs={4}>
                              <Field label="Province State">
                                <CoDropdown
                                  name="provinceState"
                                  control={control}
                                  disabled={true}
                                  options={chooseDropdoenOptions(
                                    "PROVINCES_STRY_HLDY"
                                  )}
                                />
                              </Field>
                            </Grid>
                          )}
                          {displayRules("vacationPayHourly") && (
                            <Grid item xs={4}>
                              <Field label="4% Vacation Pay Hourly">
                                <CoTextField
                                  name="vacationPayHourly"
                                  control={control}
                                  disabled
                                />
                              </Field>
                            </Grid>
                          )}
                          {displayRules("vacationPayAnnual") && (
                            <Grid item xs={4}>
                              <Field label="4% Vacation Pay Annual">
                                <CoTextField
                                  name="vacationPayAnnual"
                                  control={control}
                                  disabled
                                />
                              </Field>
                            </Grid>
                          )}
                        </Grid>
                      )}

                      <Grid container spacing={2}>
                        {displayRules("statutoryHolidays") && (
                          <Grid item xs={4}>
                            <Field label="Statutory Holidays">
                              <CoTextField
                                name="statutoryHolidays"
                                control={control}
                                disabled={true}
                              />
                            </Field>
                          </Grid>
                        )}
                        {displayRules("vacationNoOfDays") && (
                          <Grid item xs={4}>
                            <Field label="Vacation (# of Days)">
                              <CoTextField
                                name="vacationNoOfDays"
                                control={control}
                                disabled={true}
                              />
                            </Field>
                          </Grid>
                        )}
                        {displayRules("sickLeaveNoOfDays") && (
                          <Grid item xs={4}>
                            <Field label="Sick Leave (# of Days)">
                              <CoTextField
                                name="sickLeaveNoOfDays"
                                control={control}
                                disabled={true}
                              />
                            </Field>
                          </Grid>
                        )}
                      </Grid>
                      <Grid container spacing={2}>
                        {displayRules("optionalHolidays") && (
                          <Grid item xs={4}>
                            <Field label="Optional Holidays">
                              <CoTextField
                                name="optionalHolidays"
                                control={control}
                                disabled={true}
                              />
                            </Field>
                          </Grid>
                        )}
                        {displayRules("candidateInsurenceType") && (
                          <Grid item xs={4}>
                            <Field label="Insurance Type">
                              <CoDropdown
                                name="candidateInsurenceType"
                                control={control}
                                disabled={true}
                                options={chooseDropdoenOptions("INSURENCE")}
                              />
                            </Field>
                          </Grid>
                        )}
                        {displayRules("refferalAmount") && (
                          <Grid item xs={4}>
                            <Field label="Referral Fee">
                              <CoTextField
                                name="refferalAmount"
                                control={control}
                                disabled={true}
                                startAdornment={
                                  <InputAdornment position="start">
                                    $
                                  </InputAdornment>
                                }
                              />
                            </Field>
                          </Grid>
                        )}
                      </Grid>
                      <Grid container spacing={2}>
                        {displayRules("immgirationType") && (
                          <Grid item xs={4}>
                            <Field label="Immigration">
                              <CoDropdown
                                name="immgirationType"
                                control={control}
                                disabled={true}
                                options={chooseDropdoenOptions("IMMIGRATION")}
                              />
                            </Field>
                          </Grid>
                        )}
                        {displayRules("otherExpenses") && (
                          <Grid item xs={4}>
                            <Field label="Other Exp-Fixed Dollar">
                              <CoTextField
                                name="otherExpenses"
                                control={control}
                                disabled={true}
                                startAdornment={
                                  <InputAdornment position="start">
                                    $
                                  </InputAdornment>
                                }
                              />
                            </Field>
                          </Grid>
                        )}
                        {displayRules("otherExpensesHourly") && (
                          <Grid item xs={4}>
                            <Field label="Other Expenses-Hourly">
                              <CoTextField
                                name="otherExpensesHourly"
                                control={control}
                                disabled={true}
                                startAdornment={
                                  <InputAdornment position="start">
                                    $
                                  </InputAdornment>
                                }
                              />
                            </Field>
                          </Grid>
                        )}
                      </Grid>
                      {immigration === "4000" ? (
                        <Grid container>
                          <Grid item xs={5}>
                            <Controller
                              name="tnVisaCountry"
                              control={control}
                              render={({ field }) => (
                                <RadioGroup row {...field}>
                                  <FormControlLabel
                                    label="Canada"
                                    value="CA"
                                    control={
                                      <Checkbox
                                        disabled
                                        checked={field.value === "CA"}
                                        onChange={() =>
                                          setValue("tnVisaCountry", "CA")
                                        }
                                      />
                                    }
                                  />
                                  <FormControlLabel
                                    label="Mexico"
                                    value="MX"
                                    control={
                                      <Checkbox
                                        disabled
                                        checked={field.value === "MX"}
                                        onChange={() =>
                                          setValue("tnVisaCountry", "MX")
                                        }
                                      />
                                    }
                                  />
                                </RadioGroup>
                              )}
                            />

                            {tnVisaCountry && (
                              <>
                                <Controller
                                  name="tnVisaPremiumYN"
                                  control={control}
                                  render={({ field }) => (
                                    <RadioGroup row {...field}>
                                      <FormControlLabel
                                        label="Consulate"
                                        value="NO"
                                        control={<SquareRadio disabled />}
                                      />
                                      <FormControlLabel
                                        label="Petition"
                                        value="YES"
                                        control={<SquareRadio disabled />}
                                      />
                                    </RadioGroup>
                                  )}
                                />
                              </>
                            )}
                          </Grid>
                        </Grid>
                      ) : (
                        ""
                      )}
                    </AccordionDetails>
                  </Accordion>
                </Grid>
                <Grid item xs={12}>
                  <Accordion defaultExpanded>
                    <AccordionSummary
                      sx={{
                        border: "#D9D9D9 solid 1px",
                        boxShadow: "2px 2px 4px 0px rgba(1, 1, 22, 0.16)",
                      }}
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <Typography sx={{ fontWeight: 700 }}>
                        Commission & Allowance
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        {displayRules("Total Commission for # months") && (
                          <Grid item xs={6}>
                            <Field
                              label={setMydivName(
                                "totalCommissionFor24Months",
                                "Total Commission for # months"
                              )}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  gap: "14px",
                                }}
                              >
                                <CoTextField
                                  name="totalCommissionFor24Months"
                                  control={control}
                                  disabled={true}
                                  sx={{ width: "100%" }}
                                />
                                <CoTextField
                                  name="recuiterTotCommissionForMonths"
                                  control={control}
                                  sx={{ width: "100%" }}
                                  disabled={true}
                                  startAdornment={
                                    <InputAdornment position="start">
                                      {currencySymbol()}
                                    </InputAdornment>
                                  }
                                />
                              </Box>
                            </Field>
                          </Grid>
                        )}
                        {displayRules("Allowance") && (
                          <Grid item xs={6}>
                            <Field label="Allowance">
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  gap: "14px",
                                }}
                              >
                                <CoTextField
                                  name="perDiemCount"
                                  control={control}
                                  disabled={true}
                                  sx={{ width: "100%" }}
                                />
                                <CoTextField
                                  name="perDiem"
                                  control={control}
                                  sx={{ width: "100%" }}
                                  disabled={true}
                                />
                              </Box>
                            </Field>
                          </Grid>
                        )}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
                <Grid item xs={12}>
                  <Accordion expanded={!!watch("maxPay")}>
                    <AccordionSummary
                      sx={{
                        border: "#D9D9D9 solid 1px",
                        boxShadow: "2px 2px 4px 0px rgba(1, 1, 22, 0.16)",
                      }}
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1-content"
                      id="panel1-header"
                    >
                      <Typography sx={{ fontWeight: 700 }}>
                        Pay & Expenses
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={4}>
                          <Field label="Max Pay (including Allowance)">
                            <CoTextField
                              name="maxPay"
                              control={control}
                              disabled={true}
                              startAdornment={
                                <InputAdornment position="start">
                                  $
                                </InputAdornment>
                              }
                            />
                          </Field>
                        </Grid>
                        {displayRules("payRatePerDiem") && (
                          <Grid item xs={4}>
                            <Field label="Pay Rate  Allowance">
                              <CoTextField
                                name="payRatePerDiem"
                                control={control}
                                disabled={true}
                                startAdornment={
                                  <InputAdornment position="start">
                                    $
                                  </InputAdornment>
                                }
                              />
                            </Field>
                          </Grid>
                        )}
                        <Grid item xs={4}>
                          <Field label="B2BI Margin">
                            <CoTextField
                              name="b2biMargin"
                              control={control}
                              isPercentage={true}
                              disabled={true}
                            />
                          </Field>
                        </Grid>
                      </Grid>

                      <Grid container spacing={2}>
                        <Grid item xs={4}>
                          <Field label="Gross Margin">
                            <CoTextField
                              name="grossMarginPercentage"
                              control={control}
                              isPercentage={true}
                              colorind={candidateDetails.colorInd}
                              disabled={true}
                            />
                          </Field>
                        </Grid>
                        <Grid item xs={4}>
                          <Field label="Gross Margin in $">
                            <CoTextField
                              name="grossMarginDollar"
                              control={control}
                              disabled={true}
                              startAdornment={
                                <InputAdornment position="start">
                                  $
                                </InputAdornment>
                              }
                            />
                          </Field>
                        </Grid>
                        <Grid item xs={4}>
                          <Field label="Blended Gross Margin">
                            <CoTextField
                              name="blendedGrossMarginPercentage"
                              control={control}
                              isPercentage={true}
                              disabled={true}
                            />
                          </Field>
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        {displayRules("recuiterMonthlyCommission") && (
                          <Grid item xs={4}>
                            <Field
                              label={setMydivName(
                                "recuiterMonthlyCommission",
                                "Recruiter Monthly Commission"
                              )}
                            >
                              <CoTextField
                                name="recuiterMonthlyCommission"
                                control={control}
                                disabled={true}
                                startAdornment={
                                  <InputAdornment position="start">
                                    {currencySymbol()}
                                  </InputAdornment>
                                }
                              />
                            </Field>
                          </Grid>
                        )}
                        {displayRules("recMnthlyCommissionBonus") && (
                          <Grid item xs={4}>
                            <Field label="Recruiter Monthly Commission Bonus">
                              <CoTextField
                                name="recMnthlyCommissionBonus"
                                control={control}
                                disabled={true}
                                startAdornment={
                                  <InputAdornment position="start">
                                    {currencySymbol()}
                                  </InputAdornment>
                                }
                              />
                            </Field>
                          </Grid>
                        )}
                        {displayRules("recuiterMonthlyCommissionPerHour") &&
                          (!visibleAccess["recuiterMonthlyCommissionPerHour"] &&
                          workingLocation !== "CAD" ? (
                            <Grid item xs={4}>
                              <Field label="Recruiter Monthly Commission per hour worked">
                                <CoTextField
                                  name="recuiterMonthlyCommissionPerHour"
                                  control={control}
                                  disabled={true}
                                  startAdornment={
                                    <InputAdornment position="start">
                                      $
                                    </InputAdornment>
                                  }
                                />
                              </Field>
                            </Grid>
                          ) : null)}
                      </Grid>
                      <Grid container spacing={2}>
                        {displayRules("totalCommissionForMonthPro") &&
                          (!visibleAccess["totalCommissionForMonthPro"] &&
                          workingLocation !== "CAD" ? (
                            <Grid item xs={4}>
                              <Field label="Total AE Commission">
                                <CoTextField
                                  name="totalCommissionForMonthPro"
                                  control={control}
                                  disabled={true}
                                  startAdornment={
                                    <InputAdornment position="start">
                                      $
                                    </InputAdornment>
                                  }
                                />
                              </Field>
                            </Grid>
                          ) : null)}
                        {displayRules("recruiterMonthlyCommissionPro") &&
                          (!visibleAccess["recruiterMonthlyCommissionPro"] &&
                          workingLocation !== "CAD" ? (
                            <Grid item xs={4}>
                              <Field label="AE Recruiter Monthly Commission">
                                <CoTextField
                                  name="recruiterMonthlyCommissionPro"
                                  control={control}
                                  disabled={true}
                                  startAdornment={
                                    <InputAdornment position="start">
                                      $
                                    </InputAdornment>
                                  }
                                />
                              </Field>
                            </Grid>
                          ) : null)}
                        {displayRules("ttlMonthlyCommissionUSDVal") && (
                          <Grid item xs={4}>
                            <Field label="Total Commission for # months (USD)">
                              <CoTextField
                                name="ttlMonthlyCommissionUSDVal"
                                control={control}
                                disabled={true}
                                startAdornment={
                                  <InputAdornment position="start">
                                    $
                                  </InputAdornment>
                                }
                              />
                            </Field>
                          </Grid>
                        )}
                      </Grid>
                      <Grid container spacing={2}>
                        {displayRules("recruiterMonthlyCommissionUSDVal") && (
                          <Grid item xs={4}>
                            <Field label="Recruiter Monthly Commission(USD)">
                              <CoTextField
                                name="recruiterMonthlyCommissionUSDVal"
                                control={control}
                                disabled={true}
                                startAdornment={
                                  <InputAdornment position="start">
                                    $
                                  </InputAdornment>
                                }
                              />
                            </Field>
                          </Grid>
                        )}
                        {displayRules("hourlyRate") &&
                          (!visibleAccess["hourlyRate"] &&
                          workingLocation !== "CAD" ? (
                            <Grid item xs={4}>
                              <Field label="Hourly Rate">
                                <CoTextField
                                  name="hourlyRate"
                                  control={control}
                                  disabled={true}
                                  startAdornment={
                                    <InputAdornment position="start">
                                      $
                                    </InputAdornment>
                                  }
                                />
                              </Field>
                            </Grid>
                          ) : null)}

                        <Grid item xs={4} id="comments">
                          <Field
                            label="Comment"
                            required
                            error={errors?.comment?.message}
                            showError={errors?.comment?.message}
                          >
                            <CoTextField name="comment" control={control} />
                          </Field>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Box style={{ display: "flex", justifyContent: "end" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: "170px",
                      }}
                    >
                      <>
                        {!["PEN", "RET"].includes(
                          candidateDetails?.candidateStatus
                        ) ? (
                          <div style={{ display: "flex", gap: "20px" }}>
                            <div>
                              <Button
                                variant="contained"
                                className="btnLH repeateBtn"
                                disabled={
                                  employIntegration.notoficatioActionAcs ===
                                  "RO"
                                }
                                sx={{
                                  textTransform: "capitalize",
                                }}
                                // onClick={handleOpenReturn}
                                onClick={returnDialogue}
                              >
                                <Icon style={{ marginRight: "4px" }}>
                                  {<LoopOutlinedIcon />}
                                </Icon>
                                Return
                              </Button>
                            </div>
                            <Button
                              variant="contained"
                              className="btnLH declineBtn"
                              disabled={
                                employIntegration.notoficatioActionAcs === "RO"
                              }
                              onClick={handleClickOpen}
                              sx={{
                                textTransform: "capitalize",
                              }}
                            >
                              <icon
                                style={{
                                  marginRight: "6px",
                                  verticalAlign: "bottom",
                                }}
                              >
                                <ThumbDownAltOutlinedIcon />
                              </icon>
                              Decline
                            </Button>
                            <Button
                              sx={{
                                textTransform: "capitalize",
                              }}
                              variant="contained"
                              className="btnLH acceptBtn"
                              disabled={
                                employIntegration.notoficatioActionAcs === "RO"
                              }
                              onClick={() => setApproved(true)}
                            >
                              <Icon style={{ marginRight: "6px" }}>
                                <ThumbUpAltOutlinedIcon />
                              </Icon>
                              {candidateDetails?.candidateStatus === "CMP" ||
                              candidateDetails?.candidateStatus === "ONB"
                                ? "On Board"
                                : "Approve"}
                            </Button>
                          </div>
                        ) : (
                          <Button
                            variant="contained"
                            sx={{
                              textTransform: "capitalize",
                            }}
                            onClick={() => {
                              navigate(Routepath.DashboardTabsAll);
                            }}
                          >
                            Back
                          </Button>
                        )}
                      </>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </>
          ) : (
            <div style={{ alignItems: "center" }}> </div>
          )}
        </Grid>
      </Grid>
      {open && (
        <AreYouSureModel
          open={open}
          handleClose={handleClose}
          HandleCancel={handleClose}
          HandleDelete={handleSubmit((data) => saveAndPost("Denied", data))}
        />
      )}
      {approved && (
        <SucessModel
          open={approved}
          handleApprove={handleSubmit((data) => saveAndPost("Approved", data))}
          handleClose={handleClose}
          words={
            candidateDetails?.candidateStatus === "CMP" ? "On Board" : "Approve"
          }
        />
      )}
    </>
  );
};
export default AccountExeContent;
